import React from "react";
import SignInForm from '../../components/signin/SignInForm'

export default function index() {
  return (
    <SignInForm />
  );
}
